import React from 'react';

export default class QuestionIcon extends React.Component {
  render() {
    return (
        <svg className="icon icon-question" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 213 213"><path d="M106.5 0A106.5 106.5 0 1 0 213 106.5 106.44 106.44 0 0 0 106.5 0zm0 198.8a92.3 92.3 0 1 1 92.3-92.3 92.41 92.41 0 0 1-92.3 92.3zm0 0"/><path d="M103.8 129.77a9.25 9.25 0 0 0 0 18.5 9.25 9.25 0 0 0 0-18.5zm0 0M105.36 59.77c-16.21 0-23.65 9.61-23.65 16.09 0 4.69 4 6.85 7.2 6.85 6.48 0 3.84-9.25 16.09-9.25 6 0 10.81 2.64 10.81 8.17 0 6.48-6.73 10.2-10.69 13.56-3.48 3-8.05 7.93-8.05 18.25 0 6.25 1.68 8 6.61 8 5.88 0 7.08-2.64 7.08-4.92 0-6.25.12-9.85 6.73-15 3.24-2.52 13.44-10.69 13.44-22s-10.2-19.81-25.57-19.81zm0 0"/></svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon/QuestionIcon.js